import { useState } from "react";

import "./TabControl.css";

interface Props {
    tabs: string[];
    onTabChange?: (i: number) => void;
}
export default function TabControl({ tabs, onTabChange }: Props) {
    const [activeTab, setActiveTab] = useState(0);

    return (
        <div className="tab-control-container">
            {tabs.map((t, i) => {
                return (
                    <button
                        className={`category-tab${
                            activeTab === i ? " active-tab" : ""
                        }`}
                        onClick={() => {
                            setActiveTab(i);
                            if (onTabChange) onTabChange(i);
                        }}
                        key={i}
                    >
                        {t}
                    </button>
                );
            })}
        </div>
    );
}
